var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddChart = function SvgAddChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.058 20.75q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.558q0-.758.525-1.283t1.283-.525h9.154v1.5H5.057a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v13.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h13.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V9.788h1.5v9.153q0 .758-.525 1.283t-1.283.525zM7.116 17h1.5v-6.5h-1.5zM11 17h1.5V7.5H11zm3.884 0h1.5v-3.5h-1.5zm2.366-8.25v-2h-2v-1.5h2v-2h1.5v2h2v1.5h-2v2z"
  })));
};
export default SvgAddChart;